import BasicModal from "@/components/basic-modal";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";

const SessionExpirePrompt = ({ open, message, onClose, saveCallback }) => {
  return (
    <BasicModal
      open={open}
      title={"Session Expired"}
      handleClose={onClose}
      saveButtonTitle="Login"
      saveCallback={saveCallback}
      cancelBtnHidden={true}
      modalBodySx={{ padding: "1.2rem 1rem" }}
      size="xs"
      disableEscapeKeyDown={true}
      hideCloseIcon={true}
    >
      <Box sx={{ p: 0, m: 0, width: "100%" }}>
        {message && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            {message}
          </Alert>
        )}
      </Box>
    </BasicModal>
  );
};
export default SessionExpirePrompt;
